import GlobalStylesContainer from './GlobalStyles.container';

export default GlobalStylesContainer;
